export default {
  STORAGE_PREFIX: '_ROY_DESIGNER_',
  MIN_SCALE: 0.25,
  MAX_SCALE: 2
}
